import { Navigate } from 'react-router-dom';

import { NBA_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { Wheel } from '@sorare/marketplace/src/components/Wheel';

export const NBAMarketWheel = () => {
  const {
    flags: {
      marketDailyWheelBySportAndRarity = {
        baseball: { limited: false, common: false },
        football: { limited: false, common: false },
        nba: { limited: false, common: false },
      },
    },
  } = useFeatureFlags();

  if (!marketDailyWheelBySportAndRarity?.nba?.limited) {
    return <Navigate to={NBA_MARKET} replace />;
  }

  return <Wheel />;
};

export default NBAMarketWheel;
